import { render, staticRenderFns } from "./ReUsefulSquare.vue?vue&type=template&id=5f515050&scoped=true"
import script from "./ReUsefulSquare.vue?vue&type=script&lang=js"
export * from "./ReUsefulSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f515050",
  null
  
)

export default component.exports